.footer {
  position: relative;
  width: 100%;
  max-width: 1536px;
  margin: 0 auto 6rem;
  transition:
    scale 0.18s cubic-bezier(0.22, 1, 0.36, 1),
    filter 0.18s cubic-bezier(0.22, 1, 0.36, 1);

  @media (min-width: 769px) {
    margin: 0 auto 2rem;
  }

  &.fixed {
    .container {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  .cta {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 -3rem 0;
    padding: 2rem 2rem 3.25rem;
    border-radius: 1.5rem;
    background-color: var(--primary-50);

    @media (min-width: 601px) {
      padding: 2rem 3rem 4.25rem;
    }

    .ctaText {
      display: none;
      max-width: 20rem;

      @media (min-width: 601px) {
        display: flex;
        flex-direction: column;
        margin: 0 3rem 1.25rem 0;
      }

      .title {
        line-height: 3.75rem;
      }

      .description {
        line-height: 2.25rem;
      }
    }

    .ctaButton {
      margin: 0 auto 2rem;

      @media (min-width: 601px) {
        margin: 0 0 1rem;
      }
    }
  }

  .container {
    position: relative;
    width: 100%;
    padding: 1.5rem 1.5rem calc(1.5rem + env(safe-area-inset-bottom) * 1.5);
    border-radius: 1.5rem;
    background-color: var(--neutral-50);

    @media (min-width: 400px) {
      padding: 1.75rem 1.875rem
        calc(1.75rem + env(safe-area-inset-bottom) * 1.5);
    }

    @media (min-width: 769px) {
      padding: 2.3125rem 2.5rem;
    }

    @media (min-width: 1025px) {
      padding: 2.4375rem 2.625rem;
    }

    .assets {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 2.5rem;

      @media (min-width: 400px) {
        flex-direction: row;
        align-items: center;
        margin-bottom: 1.5rem;
      }

      @media (min-width: 601px) {
        margin-bottom: 2.1875rem;
      }

      @media (min-width: 769px) {
        margin-bottom: 2.375rem;
      }

      .logo {
        height: 1.75rem;

        @media (min-width: 601px) {
          height: 2.125rem;
        }

        @media (min-width: 769px) {
          height: 2.25rem;
        }

        img {
          height: 100%;
        }
      }

      .social {
        display: flex;
        height: 2rem;
        margin: 1.4375rem 0 -1.4375rem;
        margin-top: 1.4375rem;
        margin-bottom: -1.4375rem;

        @media (min-width: 400px) {
          margin: 0.125rem 0 0 auto;
        }

        @media (min-width: 601px) {
          margin-top: 0.375rem;
        }

        a {
          display: flex;
          align-items: center;

          &:not(:first-child) {
            margin-left: 0.5625rem;

            @media (min-width: 601px) {
              margin-left: 1rem;
            }
          }

          img {
            width: 2.25rem;
            height: 100%;
            max-height: 1.5rem;

            @media (min-width: 601px) {
              width: 2.5rem;
              max-height: 1.75rem;
            }

            @media (min-width: 769px) {
              width: 2.75rem;
              max-height: 1.875rem;
            }
          }
        }
      }
    }

    .links {
      display: flex;
      flex-direction: column;
      margin-bottom: 1.25rem;
      row-gap: 0.625rem;

      @media (min-width: 601px) {
        margin-bottom: 1.9375rem;
      }

      @media (min-width: 769px) {
        row-gap: 0.8125rem;
      }
    }

    .basement {
      display: flex;
      flex-direction: column-reverse;
      align-items: flex-start;

      @media (min-width: 601px) {
        flex-direction: row;
      }

      .links {
        display: flex;
        flex-direction: column;
        margin-bottom: 2rem;
        row-gap: 0.875rem;

        @media (min-width: 601px) {
          flex-direction: row;
          margin-left: auto;
        }

        a {
          display: flex;

          @media (min-width: 601px) {
            margin-left: 1.5rem;
          }

          @media (min-width: 769px) {
            margin-left: 2.375rem;
          }

          @media (min-width: 1025px) {
            margin-left: 3rem;
          }
        }
      }
    }
  }
}
